// extracted by mini-css-extract-plugin
module.exports = {"block":"TableBlock_block__OMhFO","table":"TableBlock_table__oG8Zp","table_row":"TableBlock_table_row__FEjsg","title_text":"TableBlock_title_text__miIrq"};